import { deepTopics } from "@/mocks/gossip";

export default function DeepDive() {
  const [lead, ...rest] = deepTopics;
  return (
    <section id="people" className="border-y border-background-200 bg-background-100/50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="grid h-8 w-8 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                <i className="ri-stack-line"></i>
              </span>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">人物纵深 · 深挖专栏</h2>
            </div>
            <p className="mt-1.5 text-sm text-foreground-500">不止于标题，把背景、证据与立场一次讲透</p>
          </div>
          <span className="chip border border-background-200 bg-background-50 px-3 py-1.5 text-xs text-foreground-500">
            <i className="ri-time-line"></i>每周更新
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-12">
          {/* featured lead */}
          <a href="#feed" className="group relative col-span-1 flex flex-col overflow-hidden rounded-xl bg-foreground-950 text-background-50 lg:col-span-7">
            <div className="relative aspect-[16/9] w-full overflow-hidden md:aspect-[21/10]">
              <img src={lead.img} alt={lead.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/35 to-transparent"></div>
              <span className="chip absolute left-4 top-4 bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                {lead.cat}
              </span>
            </div>
            <div className="relative -mt-16 p-5 md:-mt-20 md:p-7">
              <h3 className="font-heading text-xl font-bold leading-snug md:text-2xl">
                {lead.title}
              </h3>
              <p className="mt-3 max-w-xl text-sm leading-relaxed text-background-200/90">{lead.summary}</p>
              <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-300">
                <span className="flex items-center gap-1">
                  <i className="ri-book-open-line"></i>阅读约 {lead.read}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line text-accent-400"></i>{lead.heat} 围观
                </span>
                <span className="inline-flex items-center gap-1 text-accent-400">
                  进入专栏 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </a>

          {/* stacked rest */}
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-5 lg:grid-cols-1">
            {rest.map((d) => (
              <a key={d.id} href="#feed" className="group flex overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300">
                <div className="relative h-auto w-32 shrink-0 overflow-hidden sm:w-40">
                  <img src={d.img} alt={d.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="flex flex-1 flex-col justify-center p-4">
                  <span className="chip self-start bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">{d.cat}</span>
                  <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {d.title}
                  </h3>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600 line-clamp-2">{d.summary}</p>
                  <div className="mt-3 flex items-center gap-3 text-[11px] text-foreground-400">
                    <span>{d.read}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-primary-500"></i>{d.heat}
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}